import { render, staticRenderFns } from "./BaseCarDetails.vue?vue&type=template&id=50d348ea&scoped=true&"
import script from "./BaseCarDetails.vue?vue&type=script&lang=js&"
export * from "./BaseCarDetails.vue?vue&type=script&lang=js&"
import style0 from "./BaseCarDetails.vue?vue&type=style&index=0&id=50d348ea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d348ea",
  null
  
)

export default component.exports